export const developerLogos = [
  { name: "Adani Realty", logo: "/Adani.png", searchTerm: "adani" },
  { name: "Arkade Earth", logo: "/Arkade.png", searchTerm: "arkade"},
  { name: "Dosti - Friends For Life", logo: "/Dosti.png", searchTerm: "dosti" },
  { name: "Birla Estates", logo: "/Birla.png" , searchTerm: "birla"},
  { name: "Piramal", logo: "/Parimal.png" , searchTerm: "piramal"},
  { name: "Gera Properties", logo: "/Gera.png" , searchTerm: "gera"},
  { name: "Godrej Properties", logo: "/Godrej.png" , searchTerm: "godrej"},
  { name: "Kalpataru Properties", logo: "/Kalputru.png" , searchTerm: "kalpataru"},
  { name: "Kolte Patil", logo: "/KoltePatil.png" , searchTerm: "kolte"},
  { name: "The Wadhwa Group", logo: "/thewadwagroup.png" , searchTerm: "wadhwa"},
  { name: "L&T Realty", logo: "/LandT.png" , searchTerm: "l&t"},
  { name: "Hiranandani", logo: "/Hiranandani.png" , searchTerm: "hiranandani"},
  { name: "Mahindra Lifespaces", logo: "/Mahindra_lifespace.png" , searchTerm: "mahindra"},
  { name: "Marathon", logo: "/Marathon.png" , searchTerm: "marathon"},
  { name: "Purankas", logo: "/Purankas.png" , searchTerm: "purankas"},
  { name: "Runwal", logo: "/Runwal.png" , searchTerm: "runwal"},
  { name: "Rustomjee", logo: "/Rustomjee.png" , searchTerm: "rustomjee"},
  { name: "Shapoorji Pallonji", logo: "/Shapoorji.png" , searchTerm: "shapoorji"},
  { name: "Tata Housing", logo: "/Tata.png" , searchTerm: "tata"},
  { name: "VTP Realty", logo: "/VTP.png" , searchTerm: "vtp"}
];


export const fetchAllProperties = async () => {
  try {
    const response = await fetch("https://pp-backend-1-sa8p.onrender.com/properties");
    if (!response.ok) throw new Error("Failed to fetch properties");
    return await response.json();
  } catch (err) {
    console.error("Error fetching properties:", err);
    return [];
  }
};

export const filterPropertiesByDeveloper = (properties, searchTerm) => {
  return properties.filter(property => 
    property.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
};